module.exports = __webpack_public_path__ + "img/bg1.29940c46.jpeg";